module.exports = __webpack_public_path__ + "src/assets/images/hamberger.d4e6e49f78163c38eaa0b16afb7a20cb.png";